exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".auth-form {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin: 15% auto 0;\n  max-width: 600px;\n  padding: 2rem; }\n  .auth-form h3,\n  .auth-form input {\n    margin-bottom: 5%; }\n  .auth-form button {\n    align-self: flex-end;\n    max-width: 200px; }\n\n.container {\n  flex-grow: 1;\n  height: calc(100vh - 170px);\n  padding: 0; }\n\n.home {\n  align-items: center;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  overflow: hidden; }\n  .home h2 {\n    color: #ccc;\n    margin: 0;\n    text-align: center; }\n\n.root,\nbody,\nhtml {\n  height: 100vh;\n  overflow: hidden; }\n\n.root {\n  display: flex;\n  flex-direction: column;\n  height: 100vh; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/App.scss
// module id = 116
// module chunks = 0